// ─── Vanty Beauty Store — Main JS ─────────────────────────────────────────────

(function() {
  'use strict';

  // ─── Cart Toggle ─────────────────────────────────────────────────────────────
  var cartToggle = document.getElementById('cart-toggle');
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOverlay = document.getElementById('cart-drawer-overlay');
  var cartClose = document.getElementById('cart-close');

  function openCart() {
    fetchAndRenderCart();
    cartDrawer.style.display = 'flex';
    cartOverlay.style.display = 'block';
    document.body.style.overflow = 'hidden';
    cartDrawer.setAttribute('aria-hidden', 'false');
  }

  function closeCart() {
    cartDrawer.style.display = 'none';
    cartOverlay.style.display = 'none';
    document.body.style.overflow = '';
    cartDrawer.setAttribute('aria-hidden', 'true');
  }

  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // Close on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeCart();
  });

  // ─── Toast Notification ───────────────────────────────────────────────────────
  function showToast(message) {
    var toast = document.getElementById('toast');
    if (!toast) return;
    toast.textContent = message;
    toast.style.display = 'block';
    setTimeout(function() { toast.style.display = 'none'; }, 3000);
  }

  // ─── Format Money ─────────────────────────────────────────────────────────────
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ─── Fetch & Render Cart ─────────────────────────────────────────────────────
  function fetchAndRenderCart() {
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        renderCart(cart);
        updateCartBadge(cart.item_count);
      })
      .catch(function(err) { console.error('Cart fetch error:', err); });
  }

  function renderCart(cart) {
    var itemsEl = document.getElementById('cart-items');
    var footerEl = document.getElementById('cart-footer');
    var emptyEl = document.getElementById('cart-empty-msg');
    var totalEl = document.getElementById('cart-total-price');
    var shippingEl = document.getElementById('cart-shipping-msg');

    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      if (footerEl) footerEl.style.display = 'none';
      if (emptyEl) emptyEl.style.display = 'flex';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';
    if (footerEl) footerEl.style.display = 'block';

    // Render items
    var html = '';
    cart.items.forEach(function(item) {
      html += '<div class="cart-item" data-key="' + item.key + '">';
      html += '<img src="' + item.image + '" alt="' + item.title + '" class="cart-item-img">';
      html += '<div class="cart-item-info">';
      html += '<p class="cart-item-brand">' + item.vendor + '</p>';
      html += '<p class="cart-item-name">' + item.product_title + '</p>';
      html += '<p class="cart-item-price">' + formatMoney(item.final_line_price) + '</p>';
      html += '<div class="cart-qty">';
      html += '<button onclick="vantyChangeQty(\'' + item.key + '\',' + (item.quantity - 1) + ')">−</button>';
      html += '<span>' + item.quantity + '</span>';
      html += '<button onclick="vantyChangeQty(\'' + item.key + '\',' + (item.quantity + 1) + ')">+</button>';
      html += '<button onclick="vantyChangeQty(\'' + item.key + '\',0)" style="margin-left:auto;color:#ef4444;background:none;border:none;cursor:pointer">🗑️</button>';
      html += '</div></div></div>';
    });
    itemsEl.innerHTML = html;

    // Total & shipping
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    if (shippingEl) {
      if (cart.total_price >= 5000) {
        shippingEl.textContent = '✅ ¡Envío GRATIS incluido!';
        shippingEl.style.color = '#10b981';
      } else {
        var remaining = ((5000 - cart.total_price) / 100).toFixed(2);
        shippingEl.textContent = '📦 Agrega $' + remaining + ' más para envío gratis';
        shippingEl.style.color = '#f59e0b';
      }
    }
  }

  function updateCartBadge(count) {
    var badge = document.getElementById('cart-badge');
    if (!badge) return;
    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
    // Update aria-label
    var cartBtn = document.getElementById('cart-toggle');
    if (cartBtn) cartBtn.setAttribute('aria-label', 'Carrito (' + count + ' artículos)');
  }

  // ─── Add to Cart (AJAX) ───────────────────────────────────────────────────────
  window.vantyAddToCart = function(variantId, quantity, productTitle) {
    quantity = quantity || 1;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
    .then(function(res) { return res.json(); })
    .then(function(item) {
      showToast('✅ ' + (productTitle || item.product_title) + ' agregado');
      fetchAndRenderCart();
      openCart();
      return item;
    })
    .catch(function(err) {
      console.error('Add to cart error:', err);
      showToast('❌ Error al agregar al carrito');
    });
  };

  // Change cart item quantity
  window.vantyChangeQty = function(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      renderCart(cart);
      updateCartBadge(cart.item_count);
    });
  };

  // ─── Product card quick add ───────────────────────────────────────────────────
  window.addToCartFromCard = function(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    var title = btn.getAttribute('data-product-title');
    vantyAddToCart(variantId, 1, title);
  };

  // ─── Mobile Menu ──────────────────────────────────────────────────────────────
  var menuToggle = document.getElementById('mobile-menu-toggle');
  var mobileMenu = document.getElementById('mobile-menu');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function() {
      var isOpen = mobileMenu.style.display === 'flex';
      mobileMenu.style.display = isOpen ? 'none' : 'flex';
      menuToggle.setAttribute('aria-expanded', !isOpen);
      menuToggle.textContent = isOpen ? '☰' : '✕';
    });
  }

  // ─── Sticky Header ────────────────────────────────────────────────────────────
  var navbar = document.querySelector('.navbar');
  if (navbar) {
    window.addEventListener('scroll', function() {
      navbar.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // ─── Smooth scroll for anchor links ──────────────────────────────────────────
  document.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ─── Initialize cart badge on page load ──────────────────────────────────────
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(c) { updateCartBadge(c.item_count); });

})();
